/* eslint-disable react-hooks/exhaustive-deps */
import type { ChangeEvent, FC } from 'react';
import { useEffect, useState } from 'react';
import { Input } from '@THC/components/Input';
import { MDText } from 'i18n-react';

import { MagnifyingGlassIcon } from '@motorway/mw-highway-code';

import type { UseAccountRouterReturnType } from 'Components/Account/useAccountRouter';
import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import LocalTextsAccount from '../../../AccountPage.texts';
import LocalTexts from '../../Filters.texts';

import styles from './Search.module.scss';

const LocalT = new MDText(LocalTexts);
const LocalTAccount = new MDText(LocalTextsAccount);

type SearchProps = Pick<UseAccountRouterReturnType, 'keyword' | 'slug'> & {
	onClear: () => void;
	onSearch: (searchTerm: string | undefined) => void;
};

const Search: FC<SearchProps> = ({ keyword, onClear, onSearch, slug }) => {
	const [keywordState, setKeywordState] = useState<string>(keyword ? String(keyword) : '');

	useEffect(() => {
		setKeywordState(keyword ? String(keyword) : '');
	}, [slug, keyword]);

	return (
		<div className={styles.searchWrapper}>
			<Input
				fullWidth
				formProps={{
					input: {
						onChange: (e: ChangeEvent<HTMLInputElement>) => {
							setKeywordState(e.target.value);
							if (!e.target.value) {
								onClear();
							} else {
								onSearch(e.target.value);
							}
						},
						type: 'search',
						value: keywordState,
					},
					...applyCypressData(cypressIds.accountFilters.search),
				}}
				id="search"
				label="Search"
				placeholder={`${LocalT.translate('search')} ${LocalTAccount.translate(`pages.${slug}`)}`}
				prepend={MagnifyingGlassIcon}
			/>
		</div>
	);
};

export { Search };
